<template>
  <div class="cell-wrapper" @click="$emit('click')">
    <div class="cell-title">
      <UserAvatar :src="user.avatar" :shape="shape" />
      <span>{{user.name}}</span>
      <span v-if="user.remark">({{user.remark}})</span>
    </div>
  </div>
</template>

<script>
import UserAvatar from './UserAvatar';
export default {
  name: "search-cell",
  data() {
    return {
      shape: "terse"
    }
  },
  props: {
    user: Object,
  },
  components: {
    UserAvatar
  },
};
</script>
<style scoped>
.cell-wrapper .cell-title {
  margin: 7px 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
}

.cell-wrapper:hover span {
  color: #409EFF;
}

.cell-title .avatar-box {
  margin-right: 10px;
}
</style>